
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { Core } from '../core/core'
import { SeDateTime } from './date-time.service'
export * from './'

@NgModule({
  imports: [
	CommonModule
  ],
  providers: [
    SeDateTime
  ]
})
export class SeDateTimeModule {}

export const SE_DATE_TIME_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.dateTime`

